import { isEthereumAddress, toChecksumAddress } from '@rb/shared/eip55';

/** 주소면 checksum 정규화, 아니면 null(닉네임은 호출부가 별도 resolve). */
export function normalizeAccount(input: string): string | null {
  const s = (input ?? '').trim();
  if (!s) return null;
  if (isEthereumAddress(s)) return toChecksumAddress(s);
  return null;
}

/** 소문자 기준 dedup, 첫 등장 보존. */
export function dedupeRecipients(accounts: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const a of accounts) {
    const key = a.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(a);
  }
  return out;
}

export interface ParsedPaste {
  addresses: string[];
  nicknames: string[];
}

/** 줄바꿈/콤마 구분 텍스트를 주소(정규화)와 닉네임으로 분류. */
export function parseRecipientPaste(text: string): ParsedPaste {
  const addresses: string[] = [];
  const nicknames: string[] = [];
  for (const raw of (text ?? '').split(/[\n,]/)) {
    const line = raw.trim();
    if (!line) continue;
    const addr = normalizeAccount(line);
    if (addr) addresses.push(addr);
    else nicknames.push(line);
  }
  return { addresses, nicknames };
}
